import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/lib/auth';

// You (Gary, 3 Nov 2026): settings, help and training moved off the bottom bar to your picture, top left of the
// Chats, Team, Coach and Comments screens. The first letter of your name, in the app's accent.
export function YouButton() {
  const { profile } = useAuth();
  const navigate = useNavigate();
  const name = [profile?.first_name, profile?.last_name].filter(Boolean).join(' ') || 'You';
  return (
    <button type="button" className="chats-you" onClick={() => navigate('/settings')} aria-label={`You, ${name}: settings and help`} title="You: settings, help and training">
      {name.charAt(0).toUpperCase()}
    </button>
  );
}
